import { render, staticRenderFns } from "./LKMunMehHostViewFooter.vue?vue&type=template&id=6bb574a6&scoped=true&"
import script from "./LKMunMehHostViewFooter.vue?vue&type=script&lang=js&"
export * from "./LKMunMehHostViewFooter.vue?vue&type=script&lang=js&"
import style0 from "./LKMunMehHostViewFooter.vue?vue&type=style&index=0&id=6bb574a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb574a6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VLayout,VSpacer})
